import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@components/header'
import { columnDebtorsSalesPerson } from '@utils/columns'
import Layout from '@components/Layout'
import { useNavigate } from 'react-router-dom'
import { debouncedSet } from '@utils/debounce'
import { useQuery } from '@tanstack/react-query'
import { fetchSalesPersonDebtors } from '@utils/fetchData'
import { getToday } from '@utils/time'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'
import DebtsOneSlpModal from '@components/Modal/DebtSalesPersonModal/DebtsOneSlp'
import { useSelector } from 'react-redux'
import { downloadExcel } from '@utils/downloadPdf'

const DebtorsSalesPerson = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const formattedDate = getToday()

	const [slpName, setSlpName] = useState('')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState(formattedDate)
	const [pageSize] = useState(100)
	const [page, setPage] = useState(0)
	const [loadingExcel, setLoadingExcel] = useState(false)

	const [viewModalOpen, setViewModalOpen] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)

	const { data = [], isLoading } = useQuery({
		queryKey: ['salesPersonDebtors', startDate, endDate, pageSize, page],
		queryFn: fetchSalesPersonDebtors,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleViewClick = (record) => {
		setSelectedRowData(record)
		setViewModalOpen(true)
	}

	const handleStartDate = (e) => {
		setStartDate(e.target.value)
	}

	const handleEndDate = (e) => {
		setEndDate(e.target.value)
	}

	const handleDownloadExcel = () => {
		downloadExcel({
			url: 'api/excelgenerators/export-debt-by-managers',
			params: {
				startDate,
				endDate,
				pageSize: 1000,
				pageToken: 0,
			},
			fileName: "Qazrdorlar menejerlar bo'yicha",
			onLoadingChange: setLoadingExcel,
		})
	}

	const columns = columnDebtorsSalesPerson(t, handleViewClick)

	return (
		<Layout>
			<Header
				title={'slpDebtors'}
				hasMoreData={data.length === 10}
				columns={columns}
				fdata={data}
				loading={isLoading}
				onStartDateChange={handleStartDate}
				onEndDateChange={handleEndDate}
				startDate={startDate}
				endDate={endDate}
				formattedDate={formattedDate}
				isShowExcelBtn
				handleDownloadExcel={handleDownloadExcel}
				loadingExcel={loadingExcel}
				renderRightHeader={() => (
					<span className="font-bold">
						{t('totalDebt')} :{' '}
						{numberWithSpacesIntl(
							data?.reduce(
								(acc, cur) => acc + cur.totalOutstandingAmount,
								0,
							),
						)}
					</span>
				)}
			/>
			<DebtsOneSlpModal
				visible={viewModalOpen}
				onClose={() => setViewModalOpen(false)}
				data={selectedRowData}
			/>
		</Layout>
	)
}

export default DebtorsSalesPerson
